import { useState } from "react";
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";

import { mq } from "../responsive";

const activeStyle = {
  color: "#50976A",
  fontWeight: "bold",

  "&:after": {
    display: "block",
    content: `""`,
    position: "absolute",
    transform: "translateX(-50%)",
    width: "1rem",
    height: "1rem",
    backgroundColor: "#D1FAD7",
    borderRadius: "50%",
    bottom: "-2rem",
    left: "50%",
  },
};

const Tab = ({ tabs, style }) => {
  const [current, setCurrent] = useState(0);

  return (
    <div css={{ width: "100%", ...style }}>
      <ul
        css={{
          display: "inline-flex",
          justifyContent: "space-between",
          listStyle: "none",
          marginBottom: "3rem",
          width: "100%",

          [mq.md]: {
            justifyContent: "flex-start",
          },
        }}
      >
        {tabs.map((e, i) => (
          <li key={i} onClick={(e) => setCurrent(i)}>
            <span
              css={{
                color: "#ACB4BD",
                fontSize: "2rem",
                lineHeight: "3rem",
                position: "relative",
                transition: "all 0.05s ease-in",
                cursor: "pointer",
                margin: "0 3rem 0 0",

                ...(i === current ? activeStyle : {}),
              }}
            >
              {e.title}
            </span>
          </li>
        ))}
      </ul>
      <div>{tabs[current].component}</div>
    </div>
  );
};

export default Tab;
